import { NIcon } from 'naive-ui';
import { h, type Component } from 'vue';

export function RenderIcon(icon: Component, props?: any) {
  return () => h(NIcon, { ...(props ? props : {}) }, { default: () => h(icon) });
}

export default RenderIcon;
